export const storageKey = "wayfinder_v007";